import { Attachments } from 'modules/Assets/Attachments'
import { dequal } from 'dequal'
import type { ServerAsset } from '@sequencehq/api/utils/commonModels'
import {
  useSelectQuoteAttachments,
  useStoreQuoteAttachments,
  useShouldDisableModifyQuoteAttachments
} from 'Cube/domain/subdomain/attachments'
import { ASSET_ACCEPTED_MIME_TYPES } from '@sequencehq/utils'

export const QuoteAttachments = () => {
  const attachments = useSelectQuoteAttachments()
  const storeAttachments = useStoreQuoteAttachments()
  const disableModifyAttachments = useShouldDisableModifyQuoteAttachments()

  const handleAttachmentChange = (assets: ServerAsset[]) => {
    if (
      !dequal(
        assets.map(({ id }) => id),
        attachments.map(({ id }) => id)
      )
    ) {
      storeAttachments(assets)
    }
  }

  return (
    <Attachments
      initialAttachments={attachments}
      onChange={handleAttachmentChange}
      disableModifyAttachments={disableModifyAttachments}
      acceptedMimeTypes={ASSET_ACCEPTED_MIME_TYPES.quotes}
    />
  )
}
